import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppRouting} from './app.routing';
import {SharedModule} from './shared/shared.module';

import {AppComponent} from './app.component';
import {TranslateService} from './shared/services/translate.service';
import {AuthService} from './shared/services/auth.service';
import {AuthGuard} from './shared/guards/auth.guard';
import {PermissionGuard} from './shared/guards/permission.guard';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {JwtInterceptor} from './shared/interceptors/jwt.interceptor';
import {SimpleContainerComponent} from './shared/layouts/simple-container/simple-container.component';
import {FullContainerComponent} from './shared/layouts/full-container/full-container.component';
import {NavigationComponent} from './shared/layouts/navigation/navigation.component';
import {JwtService} from './shared/services/jwt.service';
import {UserService} from './shared/services/user.service';
import {CookieService} from 'ngx-cookie-service';

@NgModule({
  declarations: [
    AppComponent,
    SimpleContainerComponent,
    FullContainerComponent,
    NavigationComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRouting,
    SharedModule
  ],
  providers: [
    TranslateService,
    AuthService,
    JwtService,
    UserService,
    AuthGuard,
    PermissionGuard,
    CookieService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// D:/Projects/bid/frontend/src/app/app.module.ts